import { Form } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 1rem;
  display: flex;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  padding: 1rem 2rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin-bottom: 1rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
  margin: 0;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  padding: 1.5rem 2rem;
  flex-direction: column;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;
